import React from 'react';

import QRCode from 'qrcode.react';
import { Trans } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';

import Address from './Address';
import Logo from './logo.svg';
import QRIcon from './qr_icon.svg';

import style from './AddressBlock.scss';

const cn = bemCssModules(style, 'AddressBlock');
const ti = getTestId('AddressBlock');

export type TAddressBlock = {
  address?: string;
};

const AddressBlock: CustomFC<TAddressBlock> = ({ className, address }) => {
  if (!address) return null;

  return (
    <div className={cn(null, [className])} data-testid={ti()}>
      <Address value={address} />
      <div>
        <Trans i18nKey="deposit.qr_tip">
          <QRIcon className={cn('qr-icon')} />
        </Trans>
      </div>
      <div className={cn('qr')}>
        <QRCode
          value={address}
          className={cn('qrcode')}
          renderAs="svg"
          bgColor="var(--color-main-secondary-bg)"
          fgColor="var(--color-main-text)"
        />
        <Logo className={cn('logo')} />
      </div>
    </div>
  );
};

export default AddressBlock;
